export const DEDICATED = 'dedicated';
export const KVM = 'kvm';
export const SITE_BUILDER = 'sitebuilder';
export const SHARED = 'shared';
export const TEST_SSL = 'test_ssl';
export const SSL = 'ssl';
export const FREE = 'free';
export const ONETIME = 'onetime';
export const CLOUD = 'cloud';
export const EXTENDIFY = 'extendify';
export const ASTRA = 'astra';
export const VIP = 'vip';
